// import { createApp } from 'vue'
import Vue from "vue";
import App from './App.vue'
import router from "./router";

// icon
// import './assets/icons' // icon

// 全局使用ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// v-md
import VueMarkdownEditor from '@kangc/v-md-editor';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import Prism from 'prismjs';
VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});
Vue.use(VueMarkdownEditor);


// axios
import axios from '@/api/http_request';
Vue.prototype.axios = axios;

new Vue({
  // store,
  router,
  render: h => h(App)
}).$mount("#app");
